import { createSelector } from 'reselect';
const getAppAutoPlay = (state) => state?.config?.appAutoPlay;
const getAppMute = (state) => state?.config?.appMute;
const getGameView = (state, gameView) => gameView;
const getConfigAutoPlayFinal = (state) => state?.config?.enableVideoTabAutoPlay?.final;
const getConfigAutoPlayLive = (state) => state?.config?.enableVideoTabAutoPlay?.live;

/*
    app autoPlay setting: undefined --> use config setting and if auto play from config is set to true, mute the video.
    app autoPlay setting: true --> use app testing and if auto play from app testing is set to true, mute the video.
    app autoPlay setting: false --> no autoPlay
*/

export const autoPlayMuteHelper = ({ appAutoPlay, appMute, gameView, configAutoPlayFinal, configAutoPlayLive }) => {
    const configAutoPlay = gameView === 'final' ? configAutoPlayFinal : configAutoPlayLive;
    const hasAppAutoPlay = typeof appAutoPlay !== 'undefined';
    const hasConfigAutoPlay = typeof configAutoPlay !== 'undefined';
    const temp = { autoPlay: undefined, mute: appMute };

    if (hasAppAutoPlay) {
        return {
            autoPlay: appAutoPlay,
            mute: appAutoPlay ? true : appMute
        };
    }

    if (hasConfigAutoPlay) {
        temp.autoPlay = configAutoPlay;
        temp.mute = configAutoPlay ? true : appMute;
    }

    return temp;
};

export const getAutoPlayMuteHelper = createSelector(
    [getAppAutoPlay, getAppMute, getGameView, getConfigAutoPlayFinal, getConfigAutoPlayLive],
    (appAutoPlay, appMute, gameView, configAutoPlayFinal, configAutoPlayLive) => {
        const { autoPlay, mute } = autoPlayMuteHelper({ appAutoPlay, appMute, gameView, configAutoPlayFinal, configAutoPlayLive });

        return {
            videoTabAutoPlay: autoPlay,
            videoTabMute: mute
        };
    }
);

const getAutoPlayMuteSetting = gameView => state => getAutoPlayMuteHelper(state, gameView);

export default getAutoPlayMuteSetting;
